module.exports = __webpack_public_path__ + "img/gamesdk24.3d11dae.png";